import { currencyText } from '@/common/app/currency'
import { OrderHistory } from '@/common/model/master/orderHistory'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'

import PurchaserText from './PurchaserText'
import { orderDatetimeText } from './orderDatetimeText'

interface Props {
  order: OrderHistory
  selected: boolean
  onSelect(): void
  isScrolled: boolean
}

const OrderHistoryListRow = ({ order, selected, onSelect, isScrolled }: Props) => (
  <TableRow>
    <TableRowItem checkbox sticky={0} width={40} scrollShadow={isScrolled}>
      <CheckBox name={'orderId'} checked={selected} onChange={() => onSelect()} />
    </TableRowItem>
    <TableRowItem>
      <Text size={12} nowrap>
        {orderDatetimeText(order.order_datetime)}
      </Text>
    </TableRowItem>
    <TableRowItem width={160}>
      <PurchaserText customerId={order.customer_id} visitorId={order.visitor_id} />
    </TableRowItem>
    <TableRowItem>
      <Text size={12}>{order.order_number}</Text>
    </TableRowItem>
    <TableRowItem>
      <Text size={12}>{order.item_id}</Text>
    </TableRowItem>
    <TableRowItem>
      <Text nowrap>{currencyText(order.unit_price)}</Text>
    </TableRowItem>
    <TableRowItem>
      <Text>{order.quantity?.toLocaleString()}</Text>
    </TableRowItem>
    <TableRowItem>
      <Badge
        badgeType={order.source === 'tag' ? BadgeType.SQUARE_TERTIARY : BadgeType.SQUARE_SECONDARY}
      >
        {order.source === 'tag' ? 'タグ' : 'CSV'}
      </Badge>
    </TableRowItem>
  </TableRow>
)

export default OrderHistoryListRow
